import * as apiAccount from '@/network/api/accounts.api.js'
import * as mobilePaymentsApi from '@/network/api/mobilePayments.api.js'
import * as apiOperations from '@/network/api/operations/operations.api.js'

/** Get Mobile Payments status list
@return { promise }
*/
export const getMobilePaymentsStatusList = async (context, payload) => {
    const res = await mobilePaymentsApi.getMobilePaymentsStatusList()

    if (res) context.commit('SAVE_MOBILE_PAYMENT_STATUS', res.data.data)
    return res
}

/** Get Mobile Payments operations list
@return { promise }
*/
export const getMobilePaymentsList = async (context, payload) => {
    const res = await mobilePaymentsApi.getMobilePaymentsList(payload)
    if (res) context.commit('SAVE_MOBILE_PAYMENT_REQUESTS_LIST', { pageNumber: payload.pageNumber, data: res.data.data })
    return res
}

/** Get Mobile Payment Detail
@return { promise }
*/
export const getMobilePaymentDetail = async (context, payload) => {
  const res = await mobilePaymentsApi.getMobilePaymentDetail(payload)

  if (res) context.commit('SAVE_MOBILE_PAYMENT_DETAIL', res.data.data)
  return res
}

 /** Reject MobilePayments Requests
@return {promise}
  */
export const rejectMobilePayment = async (context, payload) => {
  const res = await mobilePaymentsApi.rejectMobilePayment(payload)

  return res
}

/** Generate a link to share a pdf without the need to send the file
@payload {Object}
@return {promise} - generate share link request
*/
export const generateShareLink = async (context, payload) => {
  const res = await apiOperations.generateShareLink(payload)
  return res
}

/* ***********************************************
*                                                *
*           Pay Pending Bai Paga Flow            *
*                                                *
*********************************************** */
/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
  const res = await apiAccount.requestAccountsBalances(payload)
  if (res) {
      const data = res.data.data
      context.commit('SAVE_ACCOUNTS_BALANCE', data)
  }
  return res
}

/** Pay Pending Bai Paga
@payload { Object }
@return { promise } - Pay Pending Bai Paga
*/
export const payPendingBaiPaga = async (context, payload) => {
  const res = await mobilePaymentsApi.payPendingBaiPagaRequest(payload)
  return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearPayFeatureStates = async (context, payload) => {
  context.commit('CLEAR_PAY_FEATURE_STATE')
}

export const clearConsultFeatureStates = async (context, payload) => {
  context.commit('CLEAR_CONSULT_FEATURE_STATE')
}
